export type ResearchSubmissionInput = {
  name?: string;
  clinicName?: string;
  conversationType?: string;
  currentSystem?: string;
  professionalProfile?: string;
  clinicSize?: string;
  satisfactionScore?: number;
  painPoints?: string[];
  additionalNotes?: string;
  typicalDay?: string;
  mostTimeConsumingTask?: string;
  automationWish?: string;
  reportingHabits?: string;
  studentContext?: string;
  homeCareContext?: string;
  daycareHotelContext?: string;
  decisionMaker?: string;
  interestLevel?: string;
};

export const researchSingleSelectKeys = [
  "conversationType",
  "professionalProfile",
  "decisionMaker",
  "interestLevel",
] as const;

export type DemoRequestInput = {
  name?: string;
  clinicName?: string;
  role?: string;
  whatsapp?: string;
  email?: string;
  currentSystem?: string;
  needs?: string;
  interestedInDemo?: boolean;
};

export const createEmptyDemoRequest = () => ({ interestedInDemo: false });

export const createDemoRequestPayload = (form: Record<string, string | boolean>): DemoRequestInput => ({
  name: typeof form.name === "string" ? form.name : undefined,
  clinicName: typeof form.clinic === "string" ? form.clinic : undefined,
  role: typeof form.role === "string" ? form.role : undefined,
  whatsapp: normalizeBrazilPhone(typeof form.whatsapp === "string" ? form.whatsapp : undefined) ?? undefined,
  email: typeof form.email === "string" ? form.email : undefined,
  currentSystem: typeof form.currentSystem === "string" ? form.currentSystem : undefined,
  needs: typeof form.needs === "string" ? form.needs : undefined,
  interestedInDemo: form.interestedInDemo === true,
});

export const normalizeBrazilPhone = (value?: string) => {
  const digits = (value ?? "").replace(/\D/g, "");

  if (!digits) return null;

  return digits.length >= 12 ? digits.replace(/^55(?=\d{10,11}$)/, "") : digits;
};

export const shouldRequestWhatsApp = (interested: boolean | undefined, phone: string | null) =>
  interested === true && phone !== null;
